import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService } from "../../../services/index";
import { cuttingPlanPrint } from "./cuttingPlanPrint";

declare var google;

@Component({
  selector: "fm-dc-approval",
  templateUrl: "fmDcApproval.html",
})
export class fmDcApproval implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoading: boolean = false;
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;

  filter = {
    dc_id : '',
    dc_no: "",
    from_date : "",
    to_date : "",
    groupby: "dc_no",
    status : "NOT APPROVED"
  };
  statusList = ["NOT APPROVED", "APPROVED"];
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "dc_no",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("approveTemplate") approveTemplate;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private woservice: WorkOrderService,
    public toasterService: ToasterService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {

    if(this.filter.groupby == 'wo_no'){
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Wo.no",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Date",
          prop: "work_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Dc.no",
          prop: "dc_no",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab Design",
          prop: "fab_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Cutting ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.Color",
          prop: "no_of_colors",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab.Style",
          prop: "fab_style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Fab.type",
          prop: "fab_type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },

        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Approve Status",
          prop: "approvedStatus",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
      ];
    }else{
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "DC No",
          prop: "dc_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Dc.Date",
          prop: "dc_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
  
        {
          name: "Section",
          prop: "section",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
         {
          name: "No.Of.Wo",
          prop: "total_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Design",
          prop: "total_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Total Mtr",
          prop: "total_mtr",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
        {
          name: "Approve",
          prop: "sno",
          minWidth: 80,
          maxWidth: 120,
          width: 80,
          sortable: false,
          cellTemplate: this.approveTemplate,
        },
      ];
        if(this.filter.status == 'APPROVED'){
        let approver = {
            name: "Approved by",
            prop: "wo_approver",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 150,
            maxWidth: 150,
            width: 150
        };
        this.columns.splice(9,0,approver);
      }
    }

   

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getOrderList();
  }

  clearFilter(): void {
    this.filter = {
      dc_no: "",
      dc_id: "",
      groupby: "dc_no",
      status: "NOT APPROVED",
      from_date : "",
      to_date : ""
    };
    this.applyFilter();
  }

  applyFilter(): void {
    this.getColumns();
  }
  viewFmDcList(row) {
    this.filter.dc_id = row.dc_id;
    this.filter.groupby = 'wo_no';
    this.getColumns();
  }
  gobacktoFmDcList(){
    this.filter.dc_id = '';
    this.filter.groupby = 'dc_no';
    this.getColumns();
  }
  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
    };

    params["filter"] = JSON.stringify(this.filter);
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .getApprovedDc(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }

  approveFmDc(row) {
    let that = this;
    swal({
      title: "Are you sure to Approve this Dc (" + row["dc_no"] + ") ?",
      html:
        '<input type = "text" id="approver" class="swal2-input" placeholder = "APPROVER">',
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel"
    }).then(
      function() {
        if (
          (<HTMLInputElement>document.getElementById("approver")).value != ""
        ) {
          let params = {
            dc_id: row.dc_id,
            approver: (<HTMLInputElement>document.getElementById("approver"))
              .value
          };
          that.isLoadMask = that.woservice
            .approveFmDc(params)
            .then((res: any) => {
              if(res.success){
                swal("DC No " + row.dc_no +  " Approved Successfully");
                that.getOrderList();
              }
               
            });
        } else {
          swal("PLEASE ENTER APPROVER NAME");
        }
      },
      function(dismiss) {}
    );
  }
 
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/fmDcApproval.ts